import { render, staticRenderFns } from "./JobTest.vue?vue&type=template&id=b6d31c1c&scoped=true&"
var script = {}
import style0 from "./JobTest.vue?vue&type=style&index=0&id=b6d31c1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d31c1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/nantong-hrpark-prod-mobile-company(微信公众号-企业）/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b6d31c1c', component.options)
    } else {
      api.reload('b6d31c1c', component.options)
    }
    module.hot.accept("./JobTest.vue?vue&type=template&id=b6d31c1c&scoped=true&", function () {
      api.rerender('b6d31c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/me/JobTest.vue"
export default component.exports